
angular.module('bmsApp.employeeTeam').factory('EmployeeTeamSvc', function (CRUDSvc, EMPLOYEE_TEAM_API) {

	return {
		load: function (params) {
			return CRUDSvc.get(EMPLOYEE_TEAM_API.LOAD, params);
		},
		update: function (weekDays) {
			var data = {};
			data.weekDays = weekDays;
			return CRUDSvc.post(EMPLOYEE_TEAM_API.UPDATE, data);
		}
	};

}).constant('EMPLOYEE_TEAM_API', {
	LOAD: 'api/employeeTeam/load',
	UPDATE: 'api/employeeTeam/update'
});
